import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { Checkbox } from 'primereact/checkbox';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import ProductService from '../service/ProductService';
import EventService from '../service/EventService';
import axios from "axios";

// const chartData = {
//     labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
//     datasets: [{
//         label: 'Sales',
//         data: [12, 19, 3, 5, 2, 3, 9],
//         borderColor: [
//             '#7E57C2',
//         ],
//         borderWidth: 3,
//         borderDash: [5, 5],
//         fill: false,
//         pointRadius: 3,
//         tension: .4
//     }, {
//         label: 'Income',
//         data: [1, 2, 5, 3, 12, 7, 15],
//         backgroundColor: [
//             'rgba(187,222,251,0.2)',
//         ],
//         borderColor: [
//             '#42A5F5',
//         ],
//         borderWidth: 3,
//         fill: true,
//         tension: .4
//     },
//     {
//         label: 'Expenses',
//         data: [7, 12, 15, 5, 3, 13, 21],
//         borderColor: [
//             '#FFB300',
//         ],
//         borderWidth: 3,
//         fill: false,
//         pointRadius: [4, 6, 4, 12, 8, 0, 4],
//         tension: .4
//     },
//     {
//         label: 'New Users',
//         data: [3, 7, 2, 17, 15, 13, 19],
//         borderColor: [
//             '#66BB6A',
//         ],
//         borderWidth: 3,
//         fill: false,
//         tension: .4
//     }]
// };

// const chartOptions = {
//     responsive: true,
//     hover: {
//         mode: 'index'
//     },
//     scales: {
//         x: {
//             display: true,
//             title: {
//                 display: true,
//                 text: 'Month'
//             }
//         },
//         y: {
//             display: true,
//             title: {
//                 display: true,
//                 text: 'Value'
//             }
//         }
//     }
// };

const HomeDashboard = () => {

    // const [products, setProducts] = useState([]);
    // const [events, setEvents] = useState([]);
    // const [checked1, setChecked1] = useState(false);
    // const [checked2, setChecked2] = useState(false);
    // const [checked3, setChecked3] = useState(false);
    // const [checked4, setChecked4] = useState(false);
    // const [checked5, setChecked5] = useState(false);
    // const [totalPlatforms, setTotalPlatforms] = useState(0);
    // const [totalTitles, setTotalTitles] = useState(0);
    // const [totalTemplate, setTotalTemplate] = useState(0);

    // const items = [
    //     { label: 'Save', icon: 'pi pi-fw pi-check' },
    //     { label: 'Update', icon: 'pi pi-fw pi-refresh' },
    //     { label: 'Delete', icon: 'pi pi-fw pi-trash' }
    // ];

    // const menuRef = useRef(null);

    // const loadTotalPlatforms = async () => {
    //     const url = process.env.REACT_APP_URL_PLATFORM_COUNT;
    //     axios.get(url).then(res => {
    //         setTotalPlatforms(res.data.count);
    //     });
    // }

    // const loadTotalTitles = async () => {
    //     const url = process.env.REACT_APP_URL_LIST_TITLES;
    //     axios.get(url).then(res => {
    //         const total = res.data.length;
    //         console.log(total);
    //         setTotalTitles(total);
    //     });
    // }

    // const loadTotalTemplate = async () => {
    //     const url = process.env.REACT_APP_URL_PLATFORM_TEMPLATE;
    //     axios.get(url).then(res => {
    //         const total = res.data.length;
    //         console.log(total);
    //         setTotalTemplate(total);
    //     });
    // }

    // useEffect(() => {
    //     const fetchData = async () => {
    //         loadTotalPlatforms();
    //         loadTotalTemplate();
    //         loadTotalTitles();
    //     }
    //     fetchData();
    // }, []);

    // const menuToggle = (event) => {
    //     menuRef.current.toggle(event);
    // };

    // const formatCurrency = (value) => {
    //     return value.toLocaleString('en-US', {
    //         style: 'currency',
    //         currency: 'USD',
    //     });
    // };

    // const priceBodyTemplate = (data) => {
    //     return (
    //         <>
    //             <span className="column-title">Price</span>
    //             {formatCurrency(data.price)}
    //         </>
    //     );
    // };

    // const bodyTemplate = (data, props) => {
    //     return (
    //         <>
    //             <span className="column-title">{props.header}</span>
    //             {data[props.field]}
    //         </>
    //     );
    // };

    // const statusBodyTemplate = (data) => {
    //     return (
    //         <>
    //             <span className="column-title">Status</span>
    //             <span className={`product-badge status-${data.inventoryStatus.toLowerCase()}`}>{data.inventoryStatus}</span>
    //         </>
    //     )
    // };

    return (
        // <div className="layout-dashboard">
        //     <div className="grid">
        //         <div className="col-12 lg:col-6 xl:col-3">
        //             <div className="overview-box sales">
        //                 <i className="overview-icon pi pi-check"></i>
        //                 <span className="overview-title">Platforms</span>
        //                 <i className="overview-arrow pi "></i>
        //                 <div className="overview-numbers">
        //                     {totalPlatforms}
        //                 </div>
        //                 <div className="overview-subinfo">
        //                     Sync with terminology server
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="col-12 lg:col-6 xl:col-3">
        //             <div className="overview-box views">
        //                 <i className="overview-icon pi pi-check"></i>
        //                 <span className="overview-title">Available Titles</span>
        //                 <i className="overview-arrow pi "></i>
        //                 <div className="overview-numbers">
        //                     {totalTitles}
        //                 </div>
        //                 <div className="overview-subinfo">
        //                     Sync with terminology server
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="col-12 lg:col-6 xl:col-3">
        //             <div className="overview-box users">
        //                 <i className="overview-icon pi pi-check"></i>
        //                 <span className="overview-title">Total Templates</span>
        //                 <i className="overview-arrow pi "></i>
        //                 <div className="overview-numbers">
        //                     {totalTemplate}
        //                 </div>
        //                 <div className="overview-subinfo">
        //                     Mapped fields
        //                 </div>
        //             </div>
        //         </div>

        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <div>
                        
                        <a href="https://drive.google.com/file/d/1XnzxJ_CaTGszOc46tnaBrjVMxCzIIxxg/view?usp=drive_link">About us...</a>
                    </div>
                </div>
            </div>
        </div>
        // <div className="col-12 lg:col-8">
        //     <div className="card card-w-title statistics">
        //         <h5>Statistics</h5>
        //         <Chart type="line" data={chartData} options={chartOptions} />
        //     </div>
        // </div>


        //     </div>
        // </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(HomeDashboard, comparisonFn);
